import { render, staticRenderFns } from "./ProtoMainComponent.vue?vue&type=template&id=732fd2a4&scoped=true&"
import script from "./ProtoMainComponent.vue?vue&type=script&lang=js&"
export * from "./ProtoMainComponent.vue?vue&type=script&lang=js&"
import style0 from "./ProtoMainComponent.vue?vue&type=style&index=0&id=732fd2a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732fd2a4",
  null
  
)

export default component.exports